import React from "react";
import LoginForm from "../components/common/LoginForm";
import { Helmet } from "react-helmet-async"; // For SEO

const LoginPage = () => {
  return (
    <>
      <Helmet>
        <title>Login | WeRentt</title>
        <meta
          name="description"
          content="Login to your SoWeRent Technology LLP account to manage your properties or find the perfect rental home."
        />
      </Helmet>
      <link rel="canonical" href="https://www.werentt.com/login" />
      <div>
        <LoginForm LoginFrom="LoginPage" />
      </div>
    </>
  );
};

export default LoginPage;
